import { Spinner } from '@wartek-id/spinner'

import { useApiUserDetailProfile } from 'api/competency-mapping/useAPIUserDetail'
import { useAsesmenRefleksiPeriod } from '../hooks/useAsesmenRefleksiPeriod'
import { NotStartedError } from 'utils/customError'

type EligibilityGuardProps = {
  children?: JSX.Element
  currentDateTimeServer: string
}

function EligibilityGuard({
  children,
  currentDateTimeServer,
}: EligibilityGuardProps) {
  const { isEntryOpen, isLoading: isAssesmentLoading } =
    useAsesmenRefleksiPeriod(currentDateTimeServer)

  // Hit the user detail API for eligibility check. The error will be handled by nearest ErrorBoundary
  const { isLoading, isError, data } = useApiUserDetailProfile('REFLEKSI', {
    /**
     * The eligibility check is considered to be used in every page.
     * Since the response is determined by the user identity,
     * it less likely to be changed during a session.
     * That means we can safely cache the result for a period of time (i.e. 30 min).
     * Unless the page is hard reloaded, it will not trigger refetch.
     **/
    staleTime: 30 * 60 * 1000, // stale after 30 min, force to refetch upon mounting
  })

  const role = data?.data?.role || ''

  if (isLoading || isError || isAssesmentLoading) {
    // If error, we will also return the spinner as a fallback
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Spinner size="lg" />
      </div>
    )
  }

  // check if the user is eligible but the role is KEPALA_SEKOLAH or PENGAWAS_SEKOLAH
  if (['KEPALA_SEKOLAH', 'PENGAWAS_SEKOLAH'].includes(role)) {
    // redirect to ks ps refkom page
    window.location.replace(
      `${process.env.NEXT_PUBLIC_BASE_URL}/refleksi-kompetensi-ks-ps`
    )
    return null
  }

  // check if isEntryOpen is false
  if (!isEntryOpen) {
    throw new NotStartedError(
      '/refleksi-kompetensi',
      'Service is not started yet'
    )
  }

  return children
}

export default EligibilityGuard
